import i18n from 'i18next';
import { UI_DATE_LOWER_FORMAT } from 'globalconfig/constants/static';

export const fields = {
  startDate: {
    type: 'date',
    value: '',
    field: 'startDate',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateFrom'),
    maxValue: new Date(),
  },
  endDate: {
    type: 'date',
    value: '',
    field: 'endDate',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateTo'),
    minValue: 'startDate',
    maxValue: new Date(),
  },
  driverId: {
    value: '',
    field: 'driverId',
  },
  downloadType: {
    value: '',
    field: 'downloadType',
  },
};
